import { useState } from "react";
import { Link } from "react-router-dom";

export default function Single(props) {
  const [opened, setOpened] = useState(false);

  return (
    <>
      <div
        className="relative text-white p-4 text-sm flex justify-between items-center font-medium tracking-wide overflow-hidden"
        onClick={() => setOpened(!opened)}
        style={{
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-[#3F50F6] opacity-80 pointer-events-none"></div>

        <span className="relative flex items-center gap-1 text-xs uppercase Kallisto_Bold">
          Skillzone
        </span>

        {opened ? (
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 15l7-7 7 7"
            />
          </svg>
        ) : (
          <svg
            className="w-4 h-4 transform rotate-90"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        )}
      </div>

      {opened && (
        <>
          <Link to={`/`}>
            <div className="bg-[#3F50F6] opacity-80 p-4 text-xs uppercase Kallisto_Bold">
              LATEST SESSION
            </div>
          </Link>

          <Link to={`/skillzone-all-time`}>
            <div className="bg-[#3F50F6] opacity-80 p-4 text-xs uppercase Kallisto_Bold">
              ALL SESSIONS
            </div>
          </Link>

          <Link to={`/leaderboard`}>
            <div className="bg-[#3F50F6] opacity-80 p-4 text-xs uppercase Kallisto_Bold">
              LEADERBOARD
            </div>
          </Link>

          <Link to={`/friends`}>
            <div className="bg-[#3F50F6] opacity-80 p-4 text-xs uppercase Kallisto_Bold">
              FRIENDS
            </div>
          </Link>

          <Link to={`/fixtures`}>
            <div className="bg-red-500 p-4 text-xs uppercase Kallisto_Bold">
              GOAL HIGHLIGHTS
            </div>{" "}
          </Link>
        </>
      )}
    </>
  );
}
